class DateP extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 			
      dateSelected: false,
      showInput: false,
      dayPickerStrings: {
        months: [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre'
        ],
        shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sept', 'Oct', 'Nov', 'Dic'],
        days: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        shortDays: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        // goToToday: 'Ir al día de hoy',
        // prevMonthAriaLabel: 'Go to previous month',
        // nextMonthAriaLabel: 'Go to next month',
        // prevYearAriaLabel: 'Go to previous year',
        // nextYearAriaLabel: 'Go to next year',
        isRequiredErrorMessage: 'Este campo es requerido',
        invalidInputErrorMessage: 'Formato de fecha invalido.'
      },
      style: {
        root: ['testclase'],
        textField: [{
          position: 'fixed',
          top: 0
        }],
        callout: ['thecall'],
        icon: ['hola']
      },
      formatoFecha:'',
      currentDate: null
    }

  }

  componentDidMount() {
    if(this.props.currentDate !== '') {
      const valuesArray = this.props.currentDate.split('/');

      const momentDate = moment([valuesArray[2], parseInt(valuesArray[1]) -1, valuesArray[0]]);

      const theDate = momentDate.toDate();
  
      this.setState({currentDate: theDate});
    }
  }

  componentDidUpdate(prevProps, prevState) {

    if(prevProps.currentDate !== this.props.currentDate) {
      if(this.props.currentDate === '') {
        this.setState({currentDate: null});
      } else {
        const valuesArray = this.props.currentDate.split('/');
  
        const momentDate = moment([valuesArray[2], parseInt(valuesArray[1]) -1, valuesArray[0]]);
  
        const theDate = momentDate.toDate();
  
        this.setState({currentDate: theDate});
      }
    }
  }

  dateEvent(date){
    this.props.getDateSelected(date);
    //this.setState({currentDate: date});
  }

  render() {
    return (
      <form>
        <div className={`selectDate ${this.props.containerClasses}`}>     
          <DatePicker 
            isRequired={false}
            strings={this.state.dayPickerStrings}
            placeholder={this.props.placeholder || "Seleccione una fecha"}
            minDate={this.props.minDate || new Date(-8640000000000000)}
            maxDate={this.props.maxDate || new Date(8640000000000000)}
            allowTextInput={false}
            onSelectDate={(date) => {this.dateEvent(date);}}
            formatDate={(date) => moment(date).format('DD/MM/YYYY')}
            highlightCurrentMonth={true}
            value={this.state.currentDate}
            initialPickerDate={this.props.initialDate || undefined}
            today={this.props.todayDate || undefined}
          />
        </div>
          {this.props.showInput ?
            <div className={this.props.containerClasses}>
              <div className="input-group-prepend">
                <span className="input-group-text" ><i className="fas fa-calendar"></i></span>
              </div>
              <input type="text" className={this.props.inputClasses} disabled={this.props.isDisabled} value={this.props.currentDate} />
            </div> : null                   
          }  
      </form>
    );
  }
}

let DatePicker = Fabric.DatePicker;

export default DateP;



// WEBPACK FOOTER //
// ./base/components/datePicker.js